export type PagingMeta = {
  current_page: number
  next_page: number | null
  prev_page: number | null
  total_pages: number
  total_count: number
  per_page: number
}

export const DEFAULT_PLACES_PER_PAGE = 20
